import { HoverCard, HoverCardTrigger, HoverCardContent } from "@/components/ui/hover-card";
import { cur, cc } from "@/lib/api";

const ROWS = [
  ["Size", "6 per £10k", "0.6 per £10k"],
  ["Take profit", "25 pts", "200 pts"],
  ["Stop loss", "50 pts", "1000 pts"],
  ["Spread", "0.3", "7"],
  ["Max distance to target", "80 pts", "300 pts"],
  ["Pivot buffer", "10 pts", "Off"],
  ["Reverse at target", "Off", "Off"],
  ["Hold overnight", "Off", "Off"],
  ["Entry window", "12:00 to 21:55", "01:30 to 05:30"],
  ["Forced close", "22:00", "07:30"],
];

export function MasterInfo({ children, balance }) {
  const b = Number(balance || 0);
  const g = Math.max(Math.round(6 * b / 100) / 100, 0.1);
  const n = Math.max(Math.round(0.6 * b / 100) / 100, 0.1);
  return (
    <HoverCard openDelay={150} closeDelay={100}>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent align="start" className="w-[min(92vw,420px)] border-[#D4AF37]/30 bg-[#0B0F17]/95 p-4 text-slate-200 backdrop-blur-xl" data-testid="master-settings-hovercard">
        <div className="font-display text-sm font-semibold text-[#EBD7A0]">Master settings</div>
        <p className="mt-1 text-xs leading-relaxed text-slate-400">Applies the master preset to Gold and Nikkei. Turning it off puts back the values they had before. Other markets are not changed.</p>
        <table className="mt-3 w-full text-xs">
          <thead><tr className="text-left text-[10px] uppercase tracking-wider text-slate-500"><th className="pb-1.5 font-semibold" /><th className="pb-1.5 font-semibold">Gold</th><th className="pb-1.5 font-semibold">Nikkei</th></tr></thead>
          <tbody>
            {ROWS.map(([k, gv, nv]) => (
              <tr key={k} className="border-t border-white/[0.05]"><td className="py-1 pr-2 text-slate-400">{k}</td><td className="num py-1 pr-2">{cc(gv)}</td><td className="num py-1">{cc(nv)}</td></tr>
            ))}
          </tbody>
        </table>
        <div className="mt-3 space-y-1.5 text-xs leading-relaxed text-slate-400">
          <p><span className="text-slate-200">Sizing from balance:</span> size per point = size per {cur()}10k x balance / 10,000. It uses the paper balance, or the MT5 balance when live trading is armed.</p>
          {b > 0 && <p className="num text-[#EBD7A0]" data-testid="master-hovercard-sizes">At {cur()}{b.toLocaleString("en-GB")}: Gold {cur()}{g.toFixed(2)}/pt, Nikkei {cur()}{n.toFixed(2)}/pt</p>}
          <p>Skip outside range (price above R2 or below S2) stays on. Times are London time.</p>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
